import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import WhatsAppButton from '../components/WhatsAppButton';
import { Card, CardContent } from '../components/ui/card';
import { ChevronDown } from 'lucide-react';

const faqs = [
  { q: 'What courses does CloudXAI offer?', a: 'We offer industry-aligned programs including AI & Machine Learning, Azure Data Engineer + GenAI, Cyber Security, AWS DevOps, Python & SQL Foundation, Snowflake Data Engineering, AI Testing & Automation, and Microsoft Fabric Data Engineer.' },
  { q: 'Are the courses suitable for beginners?', a: 'Yes! Our courses range from foundation level (Python & SQL) to advanced professional programs. Our career consultation helps you identify the right starting point based on your background.' },
  { q: 'What is the duration of the training programs?', a: 'Programs range from 2 months to 3 months depending on the course. AI Testing & Automation is 9 weeks, Microsoft Fabric is 12 weeks, and most others are 2-3 months.' },
  { q: 'Do you provide placement assistance?', a: 'Absolutely. We provide end-to-end placement support including resume building, mock interviews, job referrals, and direct connections with our hiring partners across India.' },
  { q: 'What is CloudXAI Certification?', a: 'CloudXAI issues professional certifications verified through our secure digital portal. Each certificate carries a unique ID and QR code that employers can verify instantly at cloudxai.org/verify.' },
  { q: 'How can I verify a CloudXAI certificate?', a: 'Visit cloudxai.org/verify and enter the Certificate ID (format: CXAI-AI-2026-0001). You can also scan the QR code on any CloudXAI certificate for instant verification.' },
  { q: 'Is there corporate training available?', a: 'Yes, we offer customized corporate training programs designed for teams. These include instructor-led sessions, hands-on labs, and certification upon completion. Contact us for a proposal.' },
  { q: 'What are the fees for the courses?', a: 'Course fees vary based on the program and duration. We offer flexible payment options and occasional early-bird discounts. Book a free consultation to discuss pricing for your chosen course.' },
  { q: 'Can I attend classes online?', a: 'Yes, all our programs are available in both online live instructor-led and hybrid modes. You get the same hands-on experience and placement support regardless of the mode.' },
  { q: 'How do I book a free career consultation?', a: 'Simply visit our "Book a Free Session" page or click the WhatsApp button on any page. Our career counselors will help you choose the right path in AI, Data, or Cloud.' },
];

const FAQItem = ({ faq, isOpen, onClick }) => (
  <div className="border-b border-[#00E5FF]/10 last:border-none">
    <button onClick={onClick} className="w-full flex items-center justify-between py-5 text-left group" data-testid={`faq-toggle-${faqs.indexOf(faq)}`}>
      <span className="text-white font-medium text-base pr-4 group-hover:text-[#00E5FF] transition-colors">{faq.q}</span>
      <ChevronDown className={`w-5 h-5 text-[#00E5FF] flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} />
    </button>
    <div className={`overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-40 pb-5' : 'max-h-0'}`}>
      <p className="text-[#9CA3AF] text-sm leading-relaxed">{faq.a}</p>
    </div>
  </div>
);

const FAQPage = () => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <div className="min-h-screen bg-[#0B0F1A]">
      <Header />

      <section className="pt-32 pb-12 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-[#0B0F1A] to-[#020617]">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl sm:text-5xl font-bold mb-4 font-['Space_Grotesk']" data-testid="faq-heading">
            Frequently Asked <span className="bg-gradient-to-r from-[#00E5FF] to-[#1DE9B6] bg-clip-text text-transparent">Questions</span>
          </h1>
          <p className="text-lg text-[#9CA3AF]">Everything you need to know about CloudXAI programs and certifications.</p>
        </div>
      </section>

      <section className="py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto">
          <Card className="bg-[#111827] border-2 border-[#00E5FF]/20">
            <CardContent className="p-6 sm:p-8">
              {faqs.map((faq, i) => (
                <FAQItem key={i} faq={faq} isOpen={openIndex === i} onClick={() => setOpenIndex(openIndex === i ? -1 : i)} />
              ))}
            </CardContent>
          </Card>
        </div>
      </section>

      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default FAQPage;
